import { ILoginUserData, ILinkObject } from "../Models/Models";
import { buxtonLimeGreen, buxtonNavyBlue } from "../Constants/StyleConstants";
import { App } from "../Enums/App";
import { LinkType } from "../Enums/LinkType";

const productPageApps = [
    App.Match,
    App.Mobilytics,
    App.Analyze,
];

export const createExternalNavLink = (linkData: ILinkObject, user?: ILoginUserData): string => {
    return linkData.type === LinkType.External
        ? `${window.location.origin}/Products#/${linkData.link}`
        : linkData.link + `?viewing=${user.userID}`;
};

export const linkColor = (link: ILinkObject, currentApp: string):string => {
    return link.title.toUpperCase() === currentApp.toUpperCase()
        ? buxtonLimeGreen
        : buxtonNavyBlue;
};

export const treatLinkAsInternal = (link: ILinkObject, currentApp: App): boolean => {
    if (currentApp === App.Scout || link.app === App.MobilyticsPro) {
        return false;
    }

    const linkIsProduct = productPageApps.some(app => app === link.app);
    const currentAppIsProduct = productPageApps.some(app => app === currentApp);

    return linkIsProduct && currentAppIsProduct;
};
